module.exports = __webpack_public_path__ + "static/promenade-zoom-60e78af0f8b77c3cfa70a627fd6fc5ea.jpg";